/**
 * Auto-Save Manager for CAD Documents
 * Automatically saves CAD documents at regular intervals
 */

class AutoSaveManager {
  constructor(cadViewer) {
    this.cadViewer = cadViewer;
    this.enabled = true;
    this.interval = 30000; // 30 seconds default
    this.timer = null;
    this.lastSaveTime = null;
    this.hasUnsavedChanges = false;

    this.initialize();
  }

  initialize() {
    // Start auto-save timer
    this.start();

    // Listen for document changes
    this.watchForChanges();

    // Save before unload
    window.addEventListener('beforeunload', (e) => {
      if (this.hasUnsavedChanges) {
        this.saveNow();
        e.preventDefault();
        e.returnValue = 'You have unsaved changes. Are you sure you want to leave?';
        return e.returnValue;
      }
    });

    console.log('[AutoSaveManager] Initialized (interval: ${this.interval}ms)');
  }

  start() {
    if (this.timer) {
      clearInterval(this.timer);
    }

    this.timer = setInterval(() => {
      this.autoSave();
    }, this.interval);

    console.log('[AutoSaveManager] Started');
  }

  stop() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }

    console.log('[AutoSaveManager] Stopped');
  }

  async autoSave() {
    if (!this.enabled) return;
    if (!this.cadViewer.document) return;
    if (!this.hasUnsavedChanges) return;

    try {
      const success = await this.cadViewer.saveDocument();

      if (success) {
        this.lastSaveTime = new Date();
        this.hasUnsavedChanges = false;

        // Show subtle notification
        const saveIndicator = document.getElementById('autoSaveIndicator');
        if (saveIndicator) {
          saveIndicator.textContent = `Auto-saved at ${this.lastSaveTime.toLocaleTimeString()}`;
          saveIndicator.style.opacity = '1';
          setTimeout(() => {
            saveIndicator.style.opacity = '0';
          }, 2000);
        }

        console.log('[AutoSaveManager] Auto-saved at', this.lastSaveTime);
      }
    } catch (error) {
      console.error('[AutoSaveManager] Auto-save failed:', error);
    }
  }

  async saveNow() {
    if (!this.cadViewer.document) return;

    try {
      await this.cadViewer.saveDocument();
      this.lastSaveTime = new Date();
      this.hasUnsavedChanges = false;
      console.log('[AutoSaveManager] Manual save completed');
    } catch (error) {
      console.error('[AutoSaveManager] Save failed:', error);
    }
  }

  watchForChanges() {
    // Monitor document changes
    // This would integrate with the history manager
    setInterval(() => {
      if (this.cadViewer.document && this.cadViewer.document.hasUnsavedChanges) {
        this.hasUnsavedChanges = true;
      }
    }, 1000);
  }

  setInterval(milliseconds) {
    this.interval = milliseconds;
    this.start(); // Restart with new interval
  }

  enable() {
    this.enabled = true;
    this.start();
  }

  disable() {
    this.enabled = false;
    this.stop();
  }

  getStatus() {
    return {
      enabled: this.enabled,
      interval: this.interval,
      lastSaveTime: this.lastSaveTime,
      hasUnsavedChanges: this.hasUnsavedChanges
    };
  }
}

// Export
if (typeof module !== 'undefined' && module.exports) {
  module.exports = { AutoSaveManager };
}
